import {Injectable} from '@angular/core';
import Swal, {SweetAlertIcon} from 'sweetalert2';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  default(message: string) {
    return this.show(message, 'question');
  }

  info(message: string, configuration?) {
    return this.show(message, 'info', {
      background: '#d1e8ff',
      confirmButtonColor: '#3e88ff',
      ...configuration
    });
  }

  success(message: string, configuration?) {
    return this.show(message, 'success', {
      background: '#ecffe2',
      confirmButtonColor: '#00a616',
      ...configuration
    });
  }

  warn(message: string, configuration?) {
    return this.show(message, 'warning', {
      background: '#feffeb',
      confirmButtonColor: '#ffbd43',
      ...configuration
    });
  }

  error(message: string, configuration?) {
    return this.show(message, 'error', {background: '#ffe7e2', ...configuration});
  }

  private show(message: string, icon: SweetAlertIcon, configuration?) {
    const Toast = Swal.mixin({
      toast: true,
      position: 'top',
      showConfirmButton: false,
      timer: 4000,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer);
        toast.addEventListener('mouseleave', Swal.resumeTimer);
      },
      ...configuration,
    });

    return Toast.fire({
      icon: icon,
      title: message,
      showCloseButton: true,
    });
  }
}
